import { PERMISSIONS } from "utils/permissions";

export const SETTINGS_TABS = [
  {
    name: "publicHolidays",
    text: "Public Holidays",
    path: "/settings/public-holidays",
    permission: PERMISSIONS.SETTINGS_PUBLIC_HOLIDAYS,
    iconColor: "info",
    iconComponent: "event",
  },
];
